@let item = $item();
@let rejetsCount = $rejetsCount();

<div class="uikit-transition relative w-full duration-200 group-hover/menu:w-full max-2xl:w-10">
	<li class="uikit-menu-item-wrapper group/item relative list-none">
		<div
			class="uikit-transition relative flex w-full cursor-pointer flex-row items-center justify-between rounded-full pr-2 duration-200 hover:bg-primary-container hover:font-semibold group-hover/menu:w-full max-2xl:w-10"
			[class.bg-primary-container]="item.active"
			(click)="onMenu(item.link)"
		>
			<div class="flex flex-row items-center gap-3">
				<div
					class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-container text-on-background-alt"
				>
					<uikit-icon
						class="uikit-menu-item-icon-on-hover"
						[name]="item.icon"
						[fill]="item.active ? 'on-primary-container' : 'on-background-alt'"
					/>
				</div>
				<div
					class="uikit-menu-item-label uikit-transition z-0 mr-3 overflow-hidden whitespace-nowrap pl-0 text-on-background-alt opacity-100 duration-200 group-hover/menu:mr-3 group-hover/menu:w-auto group-hover/menu:opacity-100"
					[class.font-bold]="item.active"
					[class.text-on-primary-container]="item.active"
				>
					{{ item.label }}
				</div>
			</div>
			<uikit-icon
				class="uikit-transition h-6 w-6 text-on-background-alt opacity-0 duration-200 group-hover/item:rotate-180 group-hover/menu:opacity-100"
				name="angle-down"
				fill="on-background-alt"
			/>
		</div>

		<div class="uikit-menu-item-enfants">
			<div>
				<ul class="uikit-transition py-2 pl-0 duration-200 group-hover/menu:pl-6">
					@for (enfant of item.enfants ?? []; track enfant.id) {
						<li
							class="list-none"
							(click)="onMenu(enfant.link)"
						>
							<div
								class="uikit-menu-item-enfant rounded-full"
								[class]="enfant.active ? 'text-on-background' : 'text-on-background-alt'"
							>
								<div
									class="ml-4 flex h-3 w-3 rounded-full"
									[class]="enfant.active ? 'bg-primary font-medium' : 'bg-primary-container'"
								></div>
								<div class="ml-4">{{ enfant.label }}</div>
								@if (enfant.id === SideNavIds.PAIEMENT_REJETS && rejetsCount) {
									<uikit-pins
										class="ml-2"
										fill="error"
									>
										{{ rejetsCount }}
									</uikit-pins>
								}
							</div>
						</li>
					}
				</ul>
			</div>
		</div>
	</li>
</div>

@if (rejetsCount) {
	<uikit-pins-status
		class="pointer-events-none absolute left-0 top-0"
		fill="error"
	/>
}
